import { useFilterDisabledSettingsV2 } from "@api";
import { DropdownChip } from "@inputs/select/DropdownChip";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import { FormControlLabel, IconButton, Stack, Switch, Tooltip, Typography } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { CreateAction } from "@root/utils/enums/communication";
import type { Dispatch, SetStateAction } from "react";

interface ICoachingStepChangeProps {
  coachingStepChange: string | undefined;
  setCoachingStepChange: Dispatch<SetStateAction<string | undefined>>;
  createAction: CreateAction;
  setCreateAction: Dispatch<SetStateAction<CreateAction>>;
  title?: string;
  subtitle?: string;
  hiddenFields?: HiddenCoachingStepFields[];
}

export enum HiddenCoachingStepFields {
  SWITCH_COPY_EMAIL_TO_ACTION = "SWITCH_COPY_EMAIL_TO_ACTION",
}

export const CoachingStepChange = ({
  title = "Options suite à cet envoi",
  subtitle = "Suite à cet envoi vous avez le choix de faire un certain nombre de changements sur la fiche de chaque destinataire :",
  coachingStepChange,
  setCoachingStepChange,
  createAction,
  setCreateAction,
  hiddenFields = [],
}: ICoachingStepChangeProps) => {
  const { settingsV2 } = useGlobalContext();
  const options = useFilterDisabledSettingsV2(settingsV2.settingsCoachingStep);
  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant="subtitle1SemiBold" color="primary">
        {title}
      </Typography>
      <Typography variant="body1">{subtitle}</Typography>
      <Stack
        direction="row"
        sx={{
          gap: 2,
          alignItems: "center",
        }}
      >
        <DropdownChip
          variant="outlined"
          options={options}
          chipSxProps={{ maxWidth: "120px" }}
          onChange={(value) => setCoachingStepChange(value.value)}
          value={coachingStepChange ?? "Choisir l'étape"}
        />
        {coachingStepChange && (
          <Tooltip title={"Réinitialiser"}>
            <IconButton sx={{ padding: 0 }} aria-label="Réinitialiser" onClick={() => setCoachingStepChange(undefined)}>
              <RestoreOutlinedIcon color="primary" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      <Stack
        sx={{
          gap: 0,
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={createAction > CreateAction.NONE}
              onChange={(e) => setCreateAction(e.target.checked ? CreateAction.CREATE : CreateAction.NONE)}
              color="primary"
            />
          }
          label="Créer une action automatique"
          sx={{ marginLeft: "-8px" }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={createAction === CreateAction.CREATE_AND_LINK_EMAIL}
              onChange={(e) =>
                setCreateAction(e.target.checked ? CreateAction.CREATE_AND_LINK_EMAIL : CreateAction.CREATE)
              }
              disabled={createAction === CreateAction.NONE}
              color="primary"
            />
          }
          label="Copier le contenu de l'email dans cette action"
          sx={{
            marginLeft: "-8px",
            display: hiddenFields.includes(HiddenCoachingStepFields.SWITCH_COPY_EMAIL_TO_ACTION) ? "none" : "",
          }}
        />
      </Stack>
    </Stack>
  );
};
